import React from "react";
import { FilterLabelProps, BaseInputFieldFilter } from "@duosoftbg/nacid-components";

const SimpleEduLevelFilter = ({ label = "l.acquiredEduLevel", ...others }: FilterLabelProps) => {
  return (
    <>
      <BaseInputFieldFilter sm={6} md={3} fieldName={"educationalLevel"} label={label} {...others} />
    </>
  );
};

export default SimpleEduLevelFilter;
